export enum PublicProjectTypeParams {
  projectTypeUuid = "projectTypeUuid",
}
